import GeoJSON from "ol/format/GeoJSON";
import proj from "ol/proj";
import {transformExtent,transform} from 'ol/proj';
import layersMap from '../layer';
import realestateLayersMap from './layer';
import WKT from 'ol/format/WKT';
import realestateservices from "./services"
import realestateLayers from './layer';
const $=window.$
const url = contextPath+"/rest/commercialspace/parcel/search/C"
const bigSmallMapBreakpoint =  768;

const wktReader = new WKT({
			    dataProjection: "EPSG:25832",
                featureProjection: "EPSG:3857"
             });

export default class Externals {
  constructor(map,ui) {
        this.map = map;
        this.ui=ui;
        this.mapRenderedSmall=false;
        this.regexParceExtentFromEnvelope = /[+-]?\d+(\.\d+)?/g;
      
      $('#result-tab2').on('shown.bs.tab', function (e) {
          setTimeout(function(){this.map.updateSize()}.bind(this),10)
        }.bind(this))
      
      this.doSearch(false);
  }
  doDeselectAndHidePopup() {
    if (realestateLayers.selection.feature) {
      realestateLayers.selection.feature.setStyle(null)
  }
    realestateLayers.selection.feature = null;
    realestateLayers.selection.id = null;
    realestateLayers.selection.point = null;
    
    $(".selectinfo").hide();
    $(".map-inner .selectinfo").attr("data-status", "closed");
    $(".map-inner .selectinfo").attr("data-id", "");
  }
  updateOpacity(value) {
    
    realestateLayersMap.realestateLayer.setOpacity(value / 100);
    
  }
doDeselect() {
     layersMap.selectLayer.getSource().clear();
}
    
 doSearch(fit) {
	
	var formElements = $("form").serializeArray();
	var query="";
	formElements.forEach(function(elem) {
        
		if( elem.name.startsWith("j_id") || elem.name==="currentPage" || elem.name==="city_select" || elem.name==="javax.faces.ViewState" ) {
			return;
		}
		
		query+="&" + elem.name + "=" + (elem.value ==="on"?true:elem.value);
	})
	realestateLayersMap.realestateLayer.getSource().clear();
    realestateLayersMap.query = query;
    realestateservices.updateRealestate2(this.map,fit);	
}


 doHighlite(id,point) {
     
     if(id === -1) {
         if(realestateLayers.highlite.feature && realestateLayers.selection.feature != realestateLayers.highlite.feature) {
            realestateLayers.highlite.feature.setStyle(null)
         }
         
         realestateLayers.highlite.feature = null;
         return;
     }
    let selectedPoint =  wktReader.readGeometry(point);
     var feature = realestateLayers.realestateLayer.getSource().forEachFeature(feature => {
            let env = wktReader.readGeometry(feature.get("env"))
            if(env.intersectsCoordinate(selectedPoint.getCoordinates())) {
                return feature;
            }
        });
    
    //the cluster feature is in map extent
    if(feature) {
        let selectStyle = realestateLayers.realestateLayer.get("selectStyle");
        if(realestateLayers.highlite.feature && realestateLayers.selection.feature != realestateLayers.highlite.feature) {
            realestateLayers.highlite.feature.setStyle(null)
         }
        realestateLayers.highlite.feature = feature;
        feature.setStyle(selectStyle);
        
    }
	
	
	
}


 zoomTo(extent) {
	if(typeof extent === 'string') {
        extent = extent.split(",").map((val) => parseFloat(val)) 
	}
	this.map.getView().fit(
	        transformExtent(extent, "EPSG:25832", "EPSG:3857"))
}


//is used if search button is clicked, jsf ajax request is send. after response and updating dom this methode is called with 
// data.status = 'success'
//then we force map update size
 onSearchEvent(data) {
	 var status = data.status; // Can be "begin", "complete" or "success".
	    var source = data.source; // The parent HTML DOM element.

	    switch (status) {
	        case "begin": // Before the ajax request is sent.
	        	this.doSearch(true);
	            break;

	        case "complete": // After the ajax response is arrived.
	            // ...
	            break;

	        case "success": // After update of HTML DOM based on ajax response.
	            
	            $('#result-tab2').tab('show')
	            this.ui.createPagination();
                //this.ui.initAutocompleteOptions();
                
	            
	            //$('#searchResult nav a').removeClass('active');
	            //$('#result-tab').addClass('active');
	            
	            
	            break;
	    }
}

 onResetEvent(data) {
	 var status = data.status; // Can be "begin", "complete" or "success".
	    var source = data.source; // The parent HTML DOM element.

	    switch (status) {
	        case "begin": // Before the ajax request is sent.
	        	realestateLayersMap.realestateLayer.getSource().clear();
                realestateLayersMap.query = "";
                realestateservices.updateRealestate2(this.map,true);	
                
	            break;

	        case "complete": // After the ajax response is arrived.
	            // ...
	            break;

	        case "success": // After update of HTML DOM based on ajax response.
	            
	        	
	           this.ui.initAutocompleteOptions();
	           // map.updateSize();
	            //$('#searchResult nav a').removeClass('active');
	            //$('#result-tab').addClass('active');
	            
	            
	            break;
	    }
}
 onPageEvent (data) {
	 var status = data.status; // Can be "begin", "complete" or "success".
	    var source = data.source; // The parent HTML DOM element.

	    switch (status) {
	        case "begin": // Before the ajax request is sent.
	            break;
	        case "complete": // After the ajax response is arrived.
	            break;
	        case "success": // After update of HTML DOM based on ajax response.
	            this.ui.createPagination();
	            setTimeout(function(){
                           this.map.updateSize()
                    }.bind(this),40)
	            break;
	    }
}

	


     replaceMap() {
         
         if($( window ).width() < 768) {
             //we need a small map
             if(!this.mapRenderedSmall) {
                 //map is currently big, render map to small
                this.map.setTarget($("#togglemap .map-inner")[0]);
                this.mapRenderedSmall=true;
             } 
        //we need a big map
         }else {
             if(this.mapRenderedSmall){
                 //map is currently small, reder map to big
                 //map tab is active, toggle to search in big view
                 if($('#map-tab.active').length) {
                     $('#search-tab2').tab('show');
                  }
                this.map.setTarget($("#map")[0]);
                this.mapRenderedSmall=false;
              }
         }
        
    }
}